import React, { Component } from "react";
import "./Home.css";
import {Well,Glyphicon,  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,Label, PanelGroup , Panel ,Modal,FormControl,FormGroup,Collapse ,Badge } from "react-bootstrap";

import Moment from 'react-moment';
import moment from "moment"
import {InputDisplay} from '../programmerComponents/InputDisplay'
import {LogicDisplay} from '../programmerComponents/LogicDisplay'
import {DaliDisplay} from '../programmerComponents/DaliDisplay'
import ActionCreate from '../programmerComponents/ActionCreate'
import TempAlert from '../programmerComponents/TempAlert'
import InputEdit from '../programmerComponents/InputEdit'
import {MacroDisplay} from '../programmerComponents/MacroDisplay'
import MacroCreate from '../programmerComponents/MacroCreate'

import VarModify from '../programmerComponents/VarModify'
import VarModifyAll from '../programmerComponents/VarModifyAll'
import OutputDevice from '../programmerComponents/OutputDevices'
import ScheduleItem from '../programmerComponents/ScheduleItem'
import ScheduleCreate from '../programmerComponents/ScheduleCreate'
import OutStation from '../programmerComponents/OutStations'
import Bed from '../programmerComponents/Bed'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
//import myData from '../data.json';
import {PubSub,API} from "aws-amplify";
import LogicCreate from '../programmerComponents/LogicCreate'
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import "prismjs/themes/prism.css"
import { CSVLink, CSVDownload } from "react-csv";


import AltiomTerminal from'../programmerComponents/AltiomTerminal.js'


import {  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  LineChart,
  Line,
  YAxis} from 'recharts';

const host=window.location.host
const hostname=window.location.hostname

const blank_RF={
  "ctrlType": "RF_SOCKET",
  "outputHandler": "dect",
  "name": "NEW_RF_SOCKET",
  "address": 235,
  "group": 235,
  "type": "ON/OFF",
  "id": 0,
  "channel": 0
}


const blank_Relay={
 "ctrlType": "RELAY PACK",
 "outputHandler": "local485",
 "name": "NEW Wired Output",
 "address": 1,
 "type": "ON/OFF",
 "id": 0,
 "channel": 2
}

const blank_RGB={
  "ctrlType": "RGB STRIP",
  "outputHandler": "local485",
  "name": "NEW RGB Strip",
  "alertLed": false,
  "address": 1,
  "type": "ON/OFF",
  "id": 0,
  "channel": 0
}

const dev_ip="192.168.10.83"

const blankLogic={
  Description: "",
  MacroFalse: "",
  MacroTrue: "",
  enabled: true,
  level: 0,
  logic: [],
  name: "New Logic"
}

const blankSched={
  name: "New",
  days: 1,
  hours: 13,
  mins: 0,
  secs: 0,
  wdays: ["every"],
  macro: "",
  setStart:true,
  id:"0",
  enabled:true
}

const data = [{x: 100, y: 200, z: 200}, {x: 120, y: 100, z: 260},
                  {x: 170, y: 300, z: 400}, {x: 140, y: 250, z: 280},
                  {x: 150, y: 400, z: 500}, {x: 110, y: 280, z: 200}]





function CustomizedShape(r){
  return (<rect width="10" height="10" x={r.cx} y={r.cy} className="tooltipvis" ></rect>)
}

/*
function InputDisplay(props){
  var l=props.data


  let momenttime=(<Moment fromNow>{new Date(l.last*1000-2000)}</Moment>)


  if(l.last==0 || l.last==""|| l.last==undefined ){
    momenttime="---"
  }

  if(props.data.disabled===true){
    return ("")
  }
  else{
    return (<div key={l.id} onClick={()=>props.callback(props.data)} className="col textCenter" title={new Date(l.last*1000)}><div><div className={'inputCircle '+shake(l.state)}><i className={"fa "+icon_from_name(l.name)+" fa-2x"}></i></div></div>{l.name}:<b>{l.state_text}</b><p>{momenttime}</p></div> )
  }

}
*/


function ContactList(d){
  let callback=d.callback
  if(d.data.type=="CONTACT_LIST"){
    return (<h4 title={d.data.id}>{d.data.name} <Button className="pullRight" onClick={()=>callback(d.editIndex) } disabled={d.varfeedback}>Edit</Button></h4>)
  }
  else{
    return (<span></span>)
  }

}


function timeTooltip(value,name ,props){
  let t=new Date(value)
  return t.toLocaleString()
}

function graphTooltip(value,name ,props,sensor_type){
  console.log(name)
  if(name===""){
    let t=new Date(value)
    return t.toLocaleString()
  }

  //I Only want the oC if its a temp sensor
  if(sensor_type==512){
      return value+"°C"
  }
  return value



}


function findMinMax(arr) {
  let min = arr[0].state, max = arr[0].state;

  for (let i = 1, len=arr.length; i < len; i++) {
    let v = arr[i].state;
    min = (v < min) ? v : min;
    max = (v > max) ? v : max;
  }

  return [min, max];
}


const testVAR={

}
/*
const testVAR={
 "name": "Floor name",
 "value": ["test"],
 "broadcast": true,
 "user": true,
 "groups": [],
 "id": "FLOOR"
}
*/

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}


export default class ProgramHome extends Component {
    constructor(props) {
      super(props);
      this.dalitoggle=0
      this.state = {
        inputs:[],
        logic:[],
        macros:{},
        vars:{},
        uservars:[],
        outputs:[],
        imglist:[],
        shelldata:"ALTIOM #>\n",
        password_script:"",
        newMacro:false,
        newmacrokey:"",
        newTemperatureLogic:false,
        image_view:"",
        image_text:"",
        level:0,
        ROOM:"",
        PATIENT:"",
        UNIT:"",
        ROOMEdit:false,
        con:"disconnect",
        rebootalert:false,
        reboottxt:"Reboot",
        alterInput:false,
        alterLogic:false,
        dashboard:true,
        dectState:"---",
        graphData:[{time:new Date().getTime(),state:0}],
        alertData:[],
        csvData:[],
        inputGraphYaxis:"",
        current_overview:"",
        current_id:'-',
        current_name:'-',
        current_min:'-',
        current_max:'-',
        current_from:'-',
        current_to:'-',
        current_date:null,
        showStats:false,
        contactEdit:false,
        contactData:{},
        schedule:{},
        tempschedule:blankSched,
        newContact:false,
        tempLogic:{},
        tempMacro:{},
        tempNew:false,
        templogicid:"",
        showAll:false,
        advanced:false,
        week_date:"",
        summaryCSV:[],
        summaryInfo:"",
        summaryDownload:false,
        weekRangeState:"",
        weekRangeStart:"",
        weekRangeEnd:"",
        weekRangeLoading:false,
        weekRangeDownload:false,
        weekRangeCSV:[],
        editfeedback:false,
        current_type:0,
        SAFE_MODE:0,
        pendantId:"",
        pendant:false,
        pendantTime:"",
        PENDANTS:[],
        showPendantPair:false,
        editPendant:false,
        newPendant:"",
        newCastor:"",
        showOutputs:false,
        inputfilters:[],
        variableEdit:false,
        variableData:{},
        newVarMode:false,
        showHelp:false,
        macroSortByKey:"name",
        errorGraph:"",
        castor:{},
        castorSeen:false,
        initialLoad:true,
        alterSchedule:false,
        initialLoadText:"Establishing inital connection to device...",
        last_seen:new Date().getTime(),
        tempLogicid:"",
        tempLogicData:{},
        macroAssignCallback:-1,
        code:"",
        scripts:[],
        script_edit:false,
        script_name:"",
        version:"0.0.0.0",
        script_log:[],
        script_log_en:false,
        dali_bus:0,
        dali_addr:0,
        dali_cmd:0,
        dali_response:0,
        dali_bus0:[],
        dali_bus1:[],
        dali_bus2:[],
      };
    }

    checkVersion=(v)=>{
      let ver_req=v.split(".")
      let ver_real=this.state.version.split(".")
      for(let i=1;i<ver_req.length;i++){
        //alert((parseInt(ver_real[i])))
        if(parseInt(ver_real[i])< parseInt(ver_req[i])){
          return false
        }
      }
      return true



    }


startvarEdit=(data)=>{
  let temp=data
  if("type" in data){
    console.log("We have a data type")
  }else {
    console.log("data type must be determined")
    let dataType=typeof(data.value)
    if(dataType=="string"){
      temp.type="string"
    }
    if(dataType=="number"){
      temp.type="number"
    }
    if(dataType=="boolean"){
      temp.type="boolean"
    }
    if(dataType=="object"){
      if("red" in data.value){
        temp.type="RGB_Colour"
        console.log("its RGB")
      }
      if(data.value.length!=undefined){
        console.log("its an array of some kind")
        temp.type="array"
      }
    }
  }
  this.setState({"newVarMode":false})
  this.setState({"variableData":temp})
  this.setState({"variableEdit":true})
  console.log(typeof(data.value))
}

toggleOutputs=()=>{
  this.setState({"showOutputs":!this.state.showOutputs})
}
startEditPendant=()=>{
  this.setState({"newPendant":""})
  this.setState({editPendant:true})
}
endEditPendant=()=>{
  this.setState({editPendant:false})
}
addEditPendant=()=>{
  this.setState({editPendant:true})
  if(this.state.newPendant.length==8){
    let pendantlist=this.state.PENDANTS
    pendantlist.push(this.state.newPendant)
    let d={
     "name": "PENDANTS",
     "value": pendantlist,
     "broadcast": true,
     "user": true,
     "groups": [],
     "id": "PENDANTS"
   }
   console.log(d)
   this.sendit({cmd:"vars",type:"modify",id:"PENDANTS",data:d})
   this.setState({editPendant:false})
}
  else{
    alert("Invalid Pendant ID length")
  }
}

dali_callback=(d,cmd,group=0,value=0)=>{
  console.log("DALI command")
  console.log(cmd)
  console.log(group)
  console.log(d)
    this.daliToggleStop()
  if(cmd=="LEVEL"){
    this.sendit({cmd:"PIC",type:"dali",bus:d.bus,"address":(parseInt(d.addr)<<1),"command":group,response:0})
    return
  }

  if(cmd=="ON"){
    this.sendit({cmd:"PIC",type:"dali",bus:d.bus,"address":(parseInt(d.addr)<<1)|1,"command":0x05,response:0})
    return
  }
  if(cmd=="OFF"){
    this.sendit({cmd:"PIC",type:"dali",bus:d.bus,"address":(parseInt(d.addr)<<1)|1,"command":0x00,response:0})
    return
  }

  if(cmd=="ADD_GROUP"){
    console.log("ADD_GROUP")
    this.sendit({cmd:"DALI",command:"add_to_group",bus:d.bus,"address":parseInt(d.addr),group:group})
    return
  }

  if(cmd=="GET_GROUPS"){

    this.sendit({cmd:"DALI",command:"get_group",bus:d.bus,"address":parseInt(d.addr),group:group})
    return
  }

  if(cmd=="REMOVE_GROUP"){
    console.log("REMOVE_GROUP")
    this.sendit({cmd:"DALI",command:"remove_from_group",bus:d.bus,"address":parseInt(d.addr),group:group})
    return
  }

  if(cmd=="GROUP_ON"){
    this.sendit({cmd:"PIC",type:"dali",bus:d.bus,"address":(parseInt(group)<<1)|0x81,"command":0x05,response:0})
    console.log(group)
    return
  }

  if(cmd=="GROUP_OFF"){
    this.sendit({cmd:"PIC",type:"dali",bus:d.bus,"address":(parseInt(group)<<1)|0x81,"command":0x00,response:0})
    console.log(group)
    return
  }

  if(cmd=="PARAM_SET"){
      this.sendit({cmd:"DALI",command:"set_parameter",bus:d.bus,"parameter":group,"value":value})
      return
  }

if(cmd=="ADDR_MOVE"){
  this.sendit({cmd:"DALI",command:"addr_move",bus:d.bus,"source":parseInt(d.addr),"dst":parseInt(group)})
  return
}
  this.sendit({cmd:"PIC",type:"dali",bus:d.bus,"address":(parseInt(d.addr)<<1)|1,"command":cmd,response:group})



}


daliToggleStart=()=>{
  this.dalitoggle=this.dalitoggle^5
  this.sendit({cmd:"PIC",type:"dali",bus:this.state.dali_bus,address:this.state.dali_addr,command:this.dalitoggle,response:0})
  this.dali_timer = setTimeout(() => this.daliToggleStart(), 1000);
  this.setState({"dalitogglestate":"Running"})
}

daliToggleStop=()=>{
  this.dalitoggle=0
  clearTimeout(this.dali_timer)
  this.setState({"dalitogglestate":"Stopped"})
}



DaliTX=()=>{
  this.sendit({cmd:"PIC",type:"dali",bus:this.state.dali_bus,address:this.state.dali_addr,command:this.state.dali_cmd,response:this.state.dali_response})
}


sendRaw=(d)=>{
  if(d.cmd=="DALI"){
    this.daliToggleStop()
  }
  console.log(d)
  this.sendit(d)
}

send4Castor=(command)=>{
  console.log("4castor")
  console.log(command)
  if(command=="firmware"){
    let ip=host
    console.log(host)
    if(hostname=="localhost"){
      command="C0f0:"+dev_ip.split(".").join(":")
    }
    else{
      //this is going to need to take the IP of the altiom!
      command="C0f0:"+this.state.ALTIOM_IP.split(".").join(":")
    }
  }
  let d={
    cmd:"4cast",
    ip:this.state.CASTOR_IP,
    data:command
  }
  console.log(d)
  this.sendit(d)
}

newPendantChange=(e)=>{
  this.setState({"newPendant":e.target.value})
}


startEditCastor=()=>{
  this.setState({"newCastor":""})
  this.setState({editCastor:true})
}

endEditCastor=()=>{
  this.setState({editCastor:false})
}

addEditCastor=()=>{
  this.setState({editCastor:true})
  if(this.state.newCastor.length==18){
    let d={
     "name": "CASTOR",
     "value": this.state.newCastor,
     "broadcast": true,
     "user": true,
     "groups": [],
     "id": "CASTOR"
    }
    console.log(d)
    this.sendit({cmd:"vars",type:"modify",id:"CASTOR",data:d})
    this.setState({editCastor:false})
    let varstemp=this.state.vars
    varstemp.CASTOR=this.state.newCastor
    this.setState({vars:varstemp})
    //Also broadcast the change?
  }
  else{
    alert("Invalid Castor ID length")
  }
}

newCastorChange=(e)=>{
  this.setState({"newCastor":e.target.value})
}

editInputOpen=()=>{
  this.setState({alterInput:true})
}


editSchedule=()=>{

  //Load




  this.setState({alterSchedule:true})
}


handleClosealterInput=()=>{
  this.setState({alterInput:false})
}

createLogicOpen=()=>{
  //Load up dummy new logic

  let tempLogic=JSON.parse(JSON.stringify(blankLogic))
  let uid=guid()
  this.setState({tempLogicid:uid})
  this.setState({tempLogicData:tempLogic})



  this.setState({alterLogic:true})
}


createSchedOpen=()=>{
  //Load up dummy new logic

  let tempSchedule=JSON.parse(JSON.stringify(blankSched))
  let uid=guid()
  //this.setState({blankSched:uid})
  tempSchedule["id"]="SCH-"+uid
  this.setState({tempschedule:tempSchedule})
  this.setState({alterSchedule:true})
}




handleCloseShedule=()=>{
  this.setState({alterSchedule:false})
}


handleCloseLogic=()=>{
  this.setState({alterLogic:false})
}

handleCloseHelp=()=>{
  this.setState({showHelp:false})
}

handleCloseTemperatureLogic=()=>{
  this.setState({newTemperatureLogic:false})
}

newTempLogic=()=>{
  this.setState({newTemperatureLogic:true})
}

handleCloseMacro=()=>{
  this.setState({newMacro:false})
}

newMacroNamed=(name)=>{
    let blankMacro={
      name:"New macro",
      actions:[],
      interfaceOption:false,
      createdDate:new Date().getTime()
    }
    console.log(name)
    this.setState({newMacroData:blankMacro})
    this.setState({newmacrokey:name})
    this.setState({newMacro:true})
  }

  newMacro=()=>{
      let blankMacro={
        name:"New Macro",
        actions:[],
        interfaceOption:false,
        createdDate:new Date().getTime()
      }
      this.setState({newMacroData:blankMacro})
      this.setState({newmacrokey:"MAC-"+guid()})
      this.setState({newMacro:true})
    }
    componentWillUnmount(){

      console.log(this.subscription)
      try{
        this.socket.onclose=null
        this.socket.close()
      }catch(err){
        this.sendit({cmd:"RemoteProg",type:"disconnect",id:this.props.userid})
      }
    }

subscibeError=(error)=>{
  console.log("Subscibe Failed")
  console.log(error)
  console.log(this.subscription)
  this.setState({"initialLoadText":"Connection not allowed"})

}


    processMessage=(message)=>{
      //console.log("WS message")
      //console.log(message)
      var data={}
      if("provider" in message){
        console.log("Online mode")
        data=message.value
      }
      else{

        data=JSON.parse(message.data)
      }

      this.setState({"last_seen":new Date().getTime()})


      if(data.cmd=="shell"){

          if ("data" in data){

            let shelldata=this.state.shelldata
            shelldata+=data.data
            this.setState({shelldata:shelldata})
          }
          return
            //shelldata

      }


        console.log(data)
        if(data.cmd=="network"){
          console.log("Network")
          this.setState({network:data.data})
          console.log(data.data)
        }

        if(data.type=="castor"){
          this.setState({"castorSeen":true})
          this.setState({"castor":data.data})
        }




        if(data.cmd=="varchange"){
          var tempkey={}
          tempkey[data.data]=data.value
          this.setState(tempkey)
          //  this.setState({data["data"]:data.value})

          if(data.data=="SAFE_MODE"){

            if(data.value==0){

              NotificationManager.info("Disarmed, events can occur", 'Safe Mode');
            }
            else{
              NotificationManager.info("Active, events will not run", 'Safe Mode');
            }
          }
        }

        if(data.cmd=="NOTIFY"){
            NotificationManager.info(data.text, 'Info', 5000);
        }
        if(data.cmd=="DALI_DATA"){
          this.setState({"dali_bus0":data.data[0].short_device})
          this.setState({"dali_bus1":data.data[1].short_device})
          this.setState({"dali_bus2":data.data[2].short_device})

        }


        if(data.cmd=="DECT_RESPONSE"){
            if(data.data=="OPEN"){
              this.setState({dectState:"Registration Open"})
                NotificationManager.info("REGISTRATION OPEN", 'DECT');
            }
            if(data.data=="CLOSED"){
              //Registration also closes when a device has started registration process..
              this.setState({dectState:"Registration Closed"})
              if(this.dectState=="Registration Open")
                NotificationManager.info("REGISTRATION CLOSED", 'DECT');
            }
            if(data.data=="S1"){
              this.setState({dectState:"Registration Stage 1 of 3"})
            }
            if(data.data=="S2"){
              this.setState({dectState:"Registration Stage 2 of 3"})
            }
            if(data.data=="S3"){
              this.setState({dectState:"Registration Complete"})
              NotificationManager.info("REGISTRATION COMPETE", 'DECT');
            }
            if(data.type=="NOTIFY"){
                NotificationManager.info(data.data, 'Info', 5000);
            }
        }

        if(data.cmd=="pendant"){


                  if (this.state.PENDANTS.includes(data.data)){
                      this.setState({showPendantPair:false})
                      this.setState({"pendantId":data.data})
                      this.setState({"pendantId":data.data})
                      this.setState({"pendantTime":new Date()})
                      this.setState({"pendant":true})
                      //Already in our list
                            NotificationManager.info(this.state.pendantId, 'Pendant');
                  }
                  else{
                      if(data.count>10){
                        this.setState({showPendantPair:false})
                        this.setState({"pendantId":data.data})
                        this.setState({"pendantId":data.data})
                        this.setState({"pendantTime":new Date()})
                        this.setState({"pendant":true})
                        this.setState({showPendantPair:true})
                      }
                      //new pendant lets allow it to be Assigned
                  }

        }



        if(data.cmd=="update"){

          if(data.type=="all"){
            this.setState({initialLoad:false})
            this.setState(data.data)

            try{
              if(this.state.imglist.length!=0){
                  this.loadImage(this.state.imglist[0])
              }


            }catch(err){}


            console.log(this.state)
          }


          if(data.type=="image"){

            this.setState({"imglist":data.data})
            try{
              if(this.state.imglist.length!=0){
                  this.loadImage(data.data[0])
              }


            }catch(err){}
          }
          if(data.type=="schedule")
            this.setState({"schedule":data.data})
          if(data.type=="macros")
            this.setState({"macros":data.data})
          if(data.type=="logic")
            this.setState({"logic":data.data})
          }
          if(data.type=="outputs"){
            this.setState({"outputs":data.data})
          }
          if(data.type=="outstations"){
            this.setState({"outstations":data.data})
          }
          if(data.type=="script"){
            console.log("Script update")
            //We must find this script name in the logs
            let tempscripts=this.state.scripts
            NotificationManager.info(data.data.log, 'Script');
            for(var i=0;i<tempscripts.length;i++){
              if(tempscripts[i].name==data.name){
                  tempscripts[i].feedback=data.data.log
                  tempscripts[i].state=data.data.rc
                  break;
              }
            }
              this.setState({scripts:tempscripts})

          }


      if(data.cmd==="inputUpdate"){
          this.setState({"inputs":data.data})
      }

      if(data.cmd==="codeUpdate"){
          this.setState({"code":data.code})
          this.setState({"script_name":data.name})
      }


      if(data.cmd==="uservarsUpdate"){
          this.setState({"uservars":data.data})
          this.setState({"editfeedback":false})
      }

      if(data.cmd=="32-input"){
        //32input log
        if(data.type="alert")
          NotificationManager.info(data.data, 'Outstation');
      }

      if(data.cmd=="RemoteProg"){

        if(data.type=="disconnect"){
          if("userid" in this.props)
            if(this.props.userid==data.id){
              NotificationManager.error("Realtime datalink has ended", 'Altiom');
              this.setState({"initialLoadText":"Realtime datalink ended. Refresh page"})
              this.setState({"initialLoad":true})
          }
        }

      }


      if(data.cmd==="alert"){
            //data.data
            console.log("Alert LEVEL:"+data.data)
            this.setState({level:data.data})
        }
      if(data.cmd==="event"){
          var tmp=this.state.logic
            tmp[data.data].state=data.state
            tmp[data.data].time=data.time
            console.log(tmp)
            this.setState({"logic":tmp})
      }


    }


    pasteFunction=(event)=>{
      console.log(event)

        if(event.ctrlKey==true && event.keyCode==86) {
          //Do whatever when esc is pressed
          console.log("Paste")
          navigator.clipboard.readText()
            .then(text => {
              // `text` contains the text read from the clipboard
              console.log(text)
              try{
              let info=JSON.parse(text)
              if("altiom_clip" in info){
                //its for altiom

                if(info.type == "raw"){

                      this.sendit(info.data)
                }


                if(info.type == "macro"){
                  if(info.id in this.state.macros){
                    console.log("Action already exists")
                      NotificationManager.error("Action already exists", 'Action Copy');
                  }

                  else{
                    console.log(info.id)
                    console.log(info.data)
                    info.data.createdDate=new Date().getTime()
                    let macroupdate={
                      cmd:"macro",
                      type:"update",
                      index:info.id,
                      data:info.data
                    }
                    console.log(macroupdate)
                    this.sendit(macroupdate)
                      NotificationManager.info("Adding "+info.data.name, 'Action Copy');
                  }

                  console.log(this.state.macros)
                }

              }
            }catch(err){
              console.log("not config json")
              //not json so ignore
            }



            })
            .catch(err => {
              // maybe user didn't grant access to read from clipboard
              console.log('Something went wrong', err);
            });

        }


      }

    componentDidMount(){
        this.wsConnect()
           document.addEventListener("keydown", this.pasteFunction, false);
    }

    componentDidUpdate(prevProps){
      if("userid" in prevProps){
          if(prevProps.userid.length==0 && this.props.userid.length!=0){
            //Need a user id before we can connect
            this.wsConnect()
          }
      }
  }



   componentWillUnmount(){
     document.removeEventListener("keydown", this.pasteFunction, false);
   }

  remoteComsCheck(){

    if (this.state.initialLoad==true){
     this.sendit({cmd:"RemoteProg",type:"connect",id:this.props.userid})
    // this.timer = setTimeout(() => this.remoteComsStart(), 3000);
     let temptext=this.state.initialLoadText
     this.setState({"initialLoadText":temptext+"."})
     if(this.state.initialLoadText.includes("....................")==true){
       console.log("this has been going a while, lets give up?")
       this.setState({"initialLoadText":"Aborted communication attempt"})
     }else{
       this.timer = setTimeout(() => this.remoteComsCheck(), 3000);
     }
   }else{
     console.log("We have had our inital update we need to keep the connection alive or the altiom will disconnect us!")
     this.sendit({cmd:"RemoteProg",type:"refresh",id:this.props.userid})
     this.timer = setTimeout(() => this.remoteComsCheck(), 60000);
   }


   let currentTime=new Date().getTime()
   let timeDiff=currentTime-this.state.last_seen
   console.log(currentTime-this.state.last_seen)


   if(this.state.initialLoad==false){
   if(timeDiff>32000 && timeDiff<60000){
     NotificationManager.warning('Not had a message in last 30 second!', 'Connection', 2000);
   }

   if(timeDiff>60000){
     NotificationManager.error('Possible loss of communication to Altiom', 'Connection', 60000);
     this.setState({"initialLoadText":"Realtime datalink ended. Refresh page"})
     this.setState({initialLoad:true})
   }

  }





   //When was the last time we recieved a message from the altiom?



  }

    componentWillMount() {

      }

      wsConnect = () => {
        console.log("Attempting websocket connection")
        this.setState({"con":"Conencting to altiom..."})
        console.log("I think this is an effect of the way it dynamicly updates things")
      //location.host

          try{
            this.socket.close()
          }
          catch(err){}


          console.log(this.props)
          if(this.props.match.params.id){
//            alert("Interface is running online, need to do things slightly differently "+this.props.userid)

            if(this.props.userid.length==0){
              this.setState({"initialLoadText":"getting credentials"})
              console.log("Waiting for user id?")
              return
            }
            this.setState({"initialLoadText":"Establishing connection to Altiom"})
            this.subscription=PubSub.subscribe(this.props.match.params.id+'/remote/'+this.props.userid).subscribe({
                next: data => this.processMessage(data),
                error: error => this.subscibeError(error),
                close: () => console.log('Done'),
            });
            //Need a retry on this!


            this.timer = setTimeout(() => this.remoteComsCheck(), 5000);
            this.sendit({cmd:"RemoteProg",type:"connect",id:this.props.userid})
            return
        }



      if(host=="localhost:3000"){
        this.socket = new WebSocket("ws://"+dev_ip+"/ws");
      }else{
        this.socket = new WebSocket("ws://"+host+"/ws");
      }

      console.log("Socket opened")
      this.socket.onopen = this.wsOpen
      this.socket.onmessage =(message)=>this.processMessage(message)
      this.socket.onclose =(e)=>{
        console.log(e)
        console.log("Websocket has disconnected")
        try{
          this.socket.close()
        }
        catch(err){
          console.log("Failed to close?")
        }
        this.setState({"con":"disconnected"})
        try{
          this.wsConnect();
          NotificationManager.warning('Reconnecting to Altiom', 'Connection', 2000);
        }catch(err){
          console.log("WS connect has been removed")
        }
      }

      }




      wsOpen=()=>{
        console.log("Websocket opened origin disabled ")
        this.setState({"con":"Connected to Altiom"})
        NotificationManager.success('Connected', 'Connection');
        if(this.state.rebootalert==true){
            this.setState({reboottxt:"Reboot Completed"})
        }
      }


addPendant=()=>{
  console.log("Add the last paired pendant")
  if (this.state.pendantId.length!=0){
    let pendantlist=this.state.PENDANTS
    console.log(this.state.PENDANTS.includes(this.state.pendantId))
    if(this.state.PENDANTS.includes(this.state.pendantId)==false){
        pendantlist.push(this.state.pendantId)
        let d={
         "name": "PENDANTS",
         "value": pendantlist,
         "broadcast": true,
         "user": true,
         "groups": [],
         "id": "PENDANTS"
        }
        console.log(d)
        this.sendit({cmd:"vars",type:"modify",id:"PENDANTS",data:d})
    }


    console.log("Not a valid pendant")
  }else{
    //Append the id to the Variable ant update the variable, broadcast may be true so it should pop up. if not make it true


  }


}




removePendant=(index)=>{
  console.log("request to remove index:"+index)
  let pendantlist=this.state.PENDANTS
  pendantlist.splice(index,1)
  let d={
   "name": "PENDANTS",
   "value": pendantlist,
   "broadcast": true,
   "user": true,
   "groups": [],
   "id": "PENDANTS"
  }
  console.log(d)
  this.sendit({cmd:"vars",type:"modify",id:"PENDANTS",data:d})

}




macrofunc=(event,data)=>{
  console.log("Macro Callback:"+event)
  console.log(data)

  if(event=="run"){

    let d={"cmd":"macro","type":"run","id":data}
    this.sendit(d)
    //this.socket.send(JSON.stringify(d))

  }

  if(event=="copy"){




    let macro_data=this.state.macros[data]
    let d={
      "altiom_clip":true,
      "type":"macro",
      "data":macro_data,
      "id":data
    }
    d=JSON.stringify(d)
    navigator.clipboard.writeText(d)
  .then(() => {
    // Success!
      NotificationManager.info("Action copied to clipboard", 'Action Copy');
  })
  .catch(err => {

          NotificationManager.error("Only available on remote program", 'Copy');
  });
  }


  if(event=="edit"){
    let temp=JSON.stringify(this.state.macros[data])
    this.setState({newMacroData:JSON.parse(temp)})
    this.setState({newmacrokey:data})
    this.setState({newMacro:true})
  //  let d={"cmd":"macro","type":"run","id":data}
//    this.socket.send(JSON.stringify(d))




  }


  if(event=="close"){
    this.setState({newMacro:false})

  }


  if(event=="closeSuccess"){
    this.setState({newMacro:false})






    if(this.state.alterLogic==true || this.state.alterSchedule==true){
      console.log("Logic is open this Logic should send its id into the editing macro")
      let temp=this.state.tempLogicData
      if(this.state.macroAssignCallback==0){
          temp.MacroFalse=data
          this.setState({tempLogicData:temp})
      }
      if(this.state.macroAssignCallback==1){
          temp.MacroTrue=data
          this.setState({tempLogicData:temp})
      }
      if(this.state.macroAssignCallback==2){
          temp=this.state.tempschedule
          temp.macro=data
          this.setState({tempSchedule:temp})
          console.log("assign the macro to the current tempschedule")
          //temp.MacroTrue=data
          //this.setState({tempLogicData:temp})
      }
      //Clear the callback asignment so it doenst accidentially go off again
      this.setState({macroAssignCallback:-1})




    }



  }




  if(event=="delete"){

    let d={"cmd":"macro","type":"delete","index":data}
    this.sendit(d)

    //this.socket.send(JSON.stringify(d))

  }

  console.log(data)
  console.log("test")
}


newVariable=()=>{
  this.setState({variableData:{}})
  this.setState({"newVarMode":true})
  this.setState({variableEdit:true})
}


tempcallback=(d)=>{
  console.log("Temp callback")
  console.log(d)
  if(d.cmd=="edit"){
      let tempLogic=this.state.logic[d["id"]]
      let tempMacro=this.state.macros[tempLogic["MacroTrue"]]
      this.setState({tempLogic:tempLogic})
      this.setState({tempMacro:tempMacro})
      this.setState({templogicid:d["id"]})
      this.setState({tempNew:false})
      this.setState({tempedit:true})
      //this.setState({tempMacro:this.state.macro[d]})
  }
  if(d.cmd=="cancel"){
    this.setState({tempedit:false})
  }
  if(d.cmd=="new"){
    //We may need to generate a new ID!!!!!
    console.log(guid())
    this.setState({templogicid:guid()})
      this.setState({tempNew:true})
    this.setState({tempedit:true})
  }
  if(d.cmd=="save"){
      //Changes to macro and logic must be saved
      let macroupdate={
        cmd:"macro",
        type:"update",
        index:d.macro_index,
        data:d.macro
      }
      this.sendit(macroupdate)
      console.log(macroupdate)
      let logicupdate={
        cmd:"logic",
        type:"update",
        index:d.logic_index,
        data:d.logic
      }
      console.log(logicupdate)
      this.sendit(logicupdate)
      this.setState({tempedit:false})
  }
  if(d.cmd=="delete"){
      console.log("Delete Logic!! & MACRO")

      let macrodelete={
        cmd:"macro",
        type:"delete",
        index:d.macro_index
      }

      let logicdelete={
        cmd:"logic",
        type:"delete",
        index:d.logic_index
      }
      console.log(macrodelete)
      this.sendit(macrodelete)
      console.log(logicdelete)
      this.sendit(logicdelete)
this.setState({tempedit:false})


  }
}

newOutput=(d)=>{
  console.log("New Output")
  console.log(d)

  let current_ids=[]
  for (let i=0;i<this.state.outputs.length;i++){
    current_ids.push(this.state.outputs[i].id)
    console.log(this.state.outputs[i].id)
  }

  console.log("Exisiting Outputs:"+current_ids)
  for(let i=0;i<1000;i++){
    if (current_ids.includes(i)==false){
      d.id=i;
      break;
    }
  }





  //FindBlank id


  //#needs an id!

  this.sendit({
    cmd:"output",
    type:"create",
    data:d
  })


  this.setState({outEdit:false})

}

remoteInterface=()=>{
  if("userid" in this.props){
    return true
  }
  return false
}


sendit=(d)=>{


  if(d.type=="helpRF"){
    this.setState({"showHelp":true})
    return;
  }

  //Depending on mode the output should be directed differently


  if(this.state.script_log_en==true){
    let temp=this.state.script_log
    temp.push(d)
    this.setState({script_log:temp})
  }

  //console.log("Sending it...")
  //console.log(this.props)
  if("userid" in this.props){
    API.post("AltiomData", "/altiom/"+this.props.match.params.id,{body:d}).then(response => {
      console.log(response)
    }).catch(error => {
      console.log(error.response)
    });
  }
  else{
    this.socket.send(JSON.stringify(d))
  }
}

SAFEON=()=>{
  let d={"cmd":"macro","type":"run","id":"safeon"}
  this.sendit(d)


  //this.socket.send(JSON.stringify(d))
}

OPENREG=()=>{
  let d={"cmd":"DECT","type":"REG"}
  this.sendit(d)
  //this.socket.send(JSON.stringify(d))
}

SAFEOFF=()=>{
  let d={"cmd":"macro","type":"run","id":"safeoff"}
  this.sendit(d)
  //this.socket.send(JSON.stringify(d))
}

REBOOT=()=>{
  let d={cmd:"REBOOT"}
  this.setState({"rebootalert":true})
  this.setState({reboottxt:"Rebooting..."})
  this.sendit(d)
  //this.sendmsg(d)
}

sendmsg=(msg)=>{
  this.sendit(msg)
  //this.socket.send(JSON.stringify(msg))
}

inputClicked=(data)=>{
  console.log("Input Clicked")
  console.log(data)
  let server=""
  if(host=="localhost:3000"){
    server=dev_ip
  }else{
    server=host
  }
  if(this.state.dashboard==true){
  //  if(data.src=="dect"){
      let id=data.id
      this.setState({current_id:id})
      this.setState({current_name:data.name})
      let fromtime=new Date().getTime()-3600000*24
      this.setState({current_from:fromtime})
      let totime=new Date().getTime()
      this.setState({current_to:totime})
      this.setState({current_overview:"Data for "+data.name})
      this.setState({current_type:data.type})
      let type="fromto"
      this.setState({alertData:[]})
      console.log("Show temperature History")
      this.getTempData("fromto",id,fromtime,totime)
      this.getTempData("alertfromto",id,fromtime,totime)
      this.setState({showStats:true})
//    }
  }
  else{
      console.log("its a dect sensor")
      this.editInputOpen()
  }

  return
}


getTempData(type,id,fromtime,totime){
      let server=""
      if(host=="localhost:3000"){
        server=dev_ip
      }else{
        server=host
      }


      //let type="fromto"
      this.setState({errorGraph:""})
      this.setState({current_from:new Date(fromtime).getTime()})
      this.setState({current_to:new Date(totime).getTime()})
      fetch("http://"+server+'/data?type='+type+'&id='+id+'&fromtime='+fromtime+'&totime='+totime,
          {  headers: {'content-type': 'application/json'}}
        ).then(response => response.json()).then(repos => {

            //console.log(repos)
            if(repos.cmd=="fromto"){
              this.setState({ graphData:repos.data })
              let minmax=findMinMax(repos.data)
              this.setState({current_min:minmax[0]})
              this.setState({current_max:minmax[1]})


              let tempCSV=[[this.state.current_name],["Date Time","id","value"]]

              for (var i=0;i<repos.data.length;i++){
                  tempCSV.push([moment(repos.data[i].time).format('YYYY-MM-DD hh:mm:ss'),id,repos.data[i].state])

              }
              this.setState({csvData:tempCSV})
            }
            if(repos.cmd=="alertfromto"){

              this.setState({ alertData:repos.data })
            }
            if(repos.cmd=="weeksummary"){
              console.log("Week summary")
              let week_str=moment(this.state.week_date).format('YYYY-WW')
              if (repos.result==true){
                  console.log("We have data")
                  this.setState({summaryInfo:"Data for "+week_str})
                  this.setState({summaryCSV:repos.data})
                  this.setState({summaryDownload:true})
              }
              else{
                  this.setState({summaryInfo:"No data available for week "+week_str})
                  this.setState({summaryDownload:false})
              }


            }

            if(repos.cmd=="weekfromto"){
                this.setState({weekRangeLoading:false})
                if (repos.result==true){
                    console.log("We have data")
                    this.setState({weekRangeCSV:repos.data})
                    this.setState({weekRangeDownload:true})
                    this.setState({weekRangeState:"Successful"})
                }
                else{
                    this.setState({weekRangeState:"No Data found"})
                    this.setState({weekRangeDownload:false})
                }
            }




        }).catch(error  => {
    console.log('There has been a problem with your fetch operation: ' + error.message);
    this.setState({"errorGraph":"Local data is only shown for last 24h and when an SD card is present"})
    // ADD THIS THROW error

    });

}

dateChange=(e)=>{
  console.log("Date has changed")
  console.log(e.target.value)
  this.setState({current_date:e.target.value})
  console.log(e.target.value)

  let fromtime=new Date(e.target.value).getTime()
  let totime=fromtime+(3600000*24)
  this.getTempData("fromto",this.state.current_id,fromtime,totime)
  this.setState({alertData:[]})
  this.getTempData("alertfromto",this.state.current_id,fromtime,totime)


}

weekRangeStartChange=(e)=>{
  console.log("TIME START")
  this.setState({weekRangeStart:e.target.value})
}

weekRangeEndChange=(e)=>{
  console.log("TIME END")
  this.setState({weekRangeEnd:e.target.value})
}


getRange=()=>{

  let fromtime  =new Date(this.state.weekRangeStart).getTime()
  let totime  =   new Date(this.state.weekRangeEnd).getTime()
  console.log(fromtime)
  console.log(totime)
  if(isNaN(fromtime)==false && isNaN(totime)==false){
    console.log("We have two dates")
    this.setState({weekRangeLoading:true})
    this.setState({weekRangeDownload:false})
    this.setState({weekRangeState:"Checking for data"})
    this.getTempData("weekfromto","",fromtime,totime)
  }else{
    this.setState({weekRangeState:"Invalid date range"})
    console.log("Bad Dates")
  }


}



weekdateChange=(e)=>{
  console.log("Week Date Change")
  this.setState({week_date:e.target.value})
  let fromtime=new Date(e.target.value).getTime()
  this.setState({summaryInfo:"Checking for data"})
  this.setState({summaryDownload:false})
  this.getTempData("weeksummary","",fromtime,0)


}




DashToggle=()=>{
  this.setState({dashboard:!this.state.dashboard})
  this.setState({showStats:false})
  this.setState({ROOMEdit:false})
}
AdvacnedToggle=()=>{
  this.setState({advanced:!this.state.advanced})
}

showAllAlerts=()=>{
  this.setState({showAll:!this.state.showAll})
}


editContactList=(index)=>{
  console.log("edit a contact list:"+index)
  let temp=this.state.uservars[index]
  console.log(temp)
  let copytemp=JSON.stringify(temp)
  console.log(copytemp)
  temp=JSON.parse(copytemp)
  this.setState({contactData:temp})
  console.log("Data is")
  console.log(this.state.contactData)
  this.setState({newContact:false})
  this.setState({contactEdit:true})
}

newContactList=()=>{
  this.setState({contactData:{}})
  this.setState({newContact:true})
  this.setState({contactEdit:true})
}

varEditCallback=(data)=>{
  if(data.cmd=="cancel"){
    this.setState({contactEdit:false})
    this.setState({variableEdit:false})
  }
  else{
    this.sendit(data)
    this.setState({editfeedback:true})
  this.setState({contactEdit:false})
    this.setState({variableEdit:false})
  }
}


closeStats=()=>{
  this.setState({showStats:false})
}

editROOMName=()=>{
  this.setState({ROOMEdit:true})
}

roomNameChange=(e)=>{
  this.setState({"ROOM":e.target.value})
}

patientNameChange=(e)=>{
  this.setState({"PATIENT":e.target.value})
}


unitNameChange=(e)=>{
  this.setState({"UNIT":e.target.value})
}

saveROOMName=()=>{


  let d={
   "name": "Room name",
   "value": this.state.ROOM,
   "broadcast": true,
   "user": true,
   "groups": [],
   "id": "ROOM"
  }
  this.sendit({cmd:"vars",type:"modify",id:"ROOM",data:d})
  d={
   "name": "UNIT name",
   "value": this.state.UNIT,
   "broadcast": true,
   "user": true,
   "groups": [],
   "id": "UNIT"
  }
  this.sendit({cmd:"vars",type:"modify",id:"UNIT",data:d})
  d={
   "name": "PATIENT name",
   "value": this.state.PATIENT,
   "broadcast": true,
   "user": true,
   "groups": [],
   "id": "PATIENT"
  }
  this.sendit({cmd:"vars",type:"modify",id:"PATIENT",data:d})




  this.setState({ROOMEdit:false})
}



sortByChange=(key)=>{

  console.log("Change Sortby")
  this.setState({macroSortByKey:key})



}

logicSort=(a,b,c)=>{
  if(this.state.logic[a][c]<this.state.logic[b][c]){
    return -1
  }
  if(this.state.logic[a][c]>this.state.logic[b][c]){
    return 1
  }
  return 0
}


macro_sort=(a,b)=>{


  if(this.state.macroSortByKey=="createdDate"){

    let t1=this.state.macros[a][this.state.macroSortByKey]
    let t2=this.state.macros[b][this.state.macroSortByKey]
    if (t1==undefined)
      t1=0
    if (t2==undefined)
      t2=0


    if(t1<t2){
      return 1
    }
    if(t1>t2){
      return -1
    }
    return 0



  }

  if(this.state.macros[a][this.state.macroSortByKey]<this.state.macros[b][this.state.macroSortByKey]){
    return -1
  }
  if(this.state.macros[a][this.state.macroSortByKey]>this.state.macros[b][this.state.macroSortByKey]){
    return 1
  }
  return 0

}

loadImage=(e)=>{


  let name=e.split("/mnt/update/web/static/")[1]
  console.log(name)
  let img_addr=""

  if("userid" in this.props){
    //We are online
    img_addr="https://kab6ul.s3-eu-west-1.amazonaws.com/"+this.state.uid+"//mnt/update/web/static/"+name
  }else{

    if(hostname=="localhost"){
      //dev mode
      img_addr="http://"+dev_ip+"/static/"+name

    }else{
      img_addr="http://"+this.state.ALTIOM_IP+"/static/"+name

    }


  }
  //img_addr="https://kab6ul.s3-eu-west-1.amazonaws.com/"+this.state.uid+"//mnt/update/web/static/"+name
  this.setState({image_view:img_addr})
  this.setState({image_text:name})



console.log(e)

}


schedChange=(data,cmd)=>{


  if(cmd=="close"){
    //Close Request for logic
    this.setState({alterSchedule:false})
  }

  if(cmd=="edit"){

    let tempSchedule=JSON.parse(JSON.stringify(data.data))
    //alert(JSON.stringify(data.data))
    this.setState({tempschedule:tempSchedule})
  //    this.setState({tempLogicData:tempLogic})
      this.setState({alterSchedule:true})
  }
  if(cmd=="macroNewSched"){
    //Assign some logic so that the newly created macro gets inserted as the macroTrue for the our logic element
    this.setState({"macroAssignCallback":2})
    this.newMacro()
  }


  if(cmd=="macroedit"){
    console.log(data.id)
    this.macrofunc("edit",data.id)
  }

  if(cmd=="save"){
    this.sendit({"cmd":"schedule","type":"update","index":data.id,"data":data})
      this.setState({alterSchedule:false})
  }

  if(cmd=="delete"){
    this.sendit({"cmd":"schedule","type":"delete","index":data.data.id})
  }

  if(cmd=="enable"){
    this.sendit({"cmd":"schedule","type":"enable","index":data.data.id})
  }

  if(cmd=="disable"){
    this.sendit({"cmd":"schedule","type":"disable","index":data.data.id})
  }


}

logicChange=(data,cmd)=>{
  console.log(cmd+" requested for")
  let tempData=data.data
  //console.log(tempData)
  if(cmd=="delete"){
    this.sendit({"cmd":"logic","type":"delete","index":data.id})
  }
  if(cmd=="disable"){
      tempData.enabled=false
      this.sendit({"cmd":"logic","type":"update","index":data.id,"data":tempData})
  }
  if(cmd=="enable"){
    tempData.enabled=true
      this.sendit({"cmd":"logic","type":"update","index":data.id,"data":tempData})
  }

  if(cmd=="close"){
    //Close Request for logic
    this.setState({alterLogic:false})
  }

  if(cmd=="save"){
    //This should send feedback with new logicin
    //Send logic update command

    console.log("Callback top level save?")
    console.log(this.state.tempLogicData)
    this.sendit({"cmd":"logic","type":"update","index":this.state.tempLogicid,"data":this.state.tempLogicData})

    this.setState({alterLogic:false})

  }


  if(cmd=="edit"){
      let tempLogic=JSON.parse(JSON.stringify(data.data))
      this.setState({tempLogicid:data.id})
      this.setState({tempLogicData:tempLogic})
      this.setState({alterLogic:true})
  }
  if(cmd=="macroNewTrue"){
    //Assign some logic so that the newly created macro gets inserted as the macroTrue for the our logic element
    this.setState({"macroAssignCallback":1})
    this.newMacro()
  }
  if(cmd=="macroNewFalse"){
    //Assign some logic so that the newly created macro gets inserted as the macrofalse for the our logic element
    this.setState({"macroAssignCallback":0})
    this.newMacro()
  }

  if(cmd=="macroedit"){
    console.log(data.id)
    this.macrofunc("edit",data.id)
  }



}

load_script=(name)=>{
  console.log("Load script"+name)
  this.sendit({cmd:"script",type:"load",name:name})

}

run_script=(name)=>{
  console.log("run script"+name)
  this.sendit({cmd:"script",type:"run",name:name})

}




script_unlock=()=>{
  this.sendit({cmd:"script",type:"auth",password:this.state.password_script})
  this.setState({password_script:""})
}

script_lock=()=>{
  this.setState({password_script:""})
  this.sendit({cmd:"script",type:"auth",password:this.state.password_script})

}


save_script=()=>{
  this.sendit({cmd:"script",type:"save",name:this.state.script_name,"code":this.state.code})
}

    render() {
      let app=this


      if(this.state.initialLoad==true){
        return (    <div className="Home">
    <NotificationContainer/>
        <Jumbotron className={"alertLeft event0"}>
        <p>{this.state.initialLoadText}</p>
        </Jumbotron>
        </div>
)




      }


      return (
          <div className="Home">
          <NotificationContainer/>
          <Jumbotron className={"alertLeft event"+this.state.level}>
          <div className="pull-right">

          {this.state.macros["safeon"]==undefined ? (<span>No safe mode</span>):(
            <span>
          <Button onClick={this.SAFEON}>Safe Mode ON</Button>
          <Button onClick={this.SAFEOFF}>Safe Mode OFF</Button>
          </span>
        )}


          {!this.state.dashboard? (<Button onClick={()=>this.REBOOT()}>{this.state.reboottxt}</Button>):("")}
            {/*{!this.state.dashboard? (<span><br/>{this.state.uid} --- {this.state.version}&nbsp;websocket:{this.state.con}</span>):("")} */}
            {/* if Safe mode macro exists then...*/}
            {/*<p>Safe mode is currently {this.state.SAFE_MODE==1 ?("ON"):("OFF")}</p>*/}
  </div>

            {this.state.ROOMEdit ? (
              <div>
              <h3>UNIT:</h3><input value={this.state.UNIT} onChange={this.unitNameChange}></input>
              <h3>ROOM:</h3><input value={this.state.ROOM} onChange={this.roomNameChange}></input>
              <h3>PATIENT:</h3><input value={this.state.PATIENT} onChange={this.patientNameChange}></input>
              <Button onClick={()=>this.saveROOMName()}>Done</Button>
              </div>
            ):(
              <div>
            <h2><b>UNIT:</b>{this.state.UNIT} <br/><b>ROOM:</b> {this.state.ROOM}  <br/><b>PATIENT:</b> {this.state.PATIENT}&nbsp;  {!this.state.dashboard? (<Glyphicon onClick={()=>this.editROOMName()} title="Edit name" className="iconBut" glyph="pencil" />):("")}</h2>
            </div>


          )
            }

            {this.state.SAFE_MODE==0 ? (<Badge key="safemode"> Safe Mode Inactive</Badge>):(<Badge key="safemode"> Safe Mode Active</Badge>)}
            &nbsp;
            {this.state.CLOUD_STATE==1 ? (<Badge key="cloud"> Cloud Connected</Badge>):("")}
            &nbsp;
            {this.state.INTERNET_STATE==false ? (<Badge key="cloud"> No Internet!!!</Badge>):("")}




          <span></span>


            <h2>Sensors&nbsp;
            {!this.state.dashboard? (<span><Button onClick={this.inputClicked}>Edit Inputs</Button><Button onClick={this.OPENREG}>Start Wireless Pairing</Button>&nbsp;<span className="dectResponseText">{this.state.dectState}</span></span>):(<span className="smallText"> Click Sensor for logs</span>)}
            </h2>
            <div className="flex-grid" key="inputFlex">
            {this.state.inputs.map((l) =><InputDisplay key={l.id} data={l} logic={this.state.logic} callback={this.inputClicked}></InputDisplay>
          )}</div>



            {this.state.showStats ?(
            <Well>
              <center><h4>{this.state.current_overview}</h4></center>
              <center><h4>{this.state.errorGraph}</h4></center>

              <div className="graphContainer">
              <ResponsiveContainer>
                <LineChart  data={this.state.graphData}>
                  <XAxis
                    dataKey = 'time'
                    domain={['dataMin', 'dataMax']}
                    name = 'Time'
                    tickFormatter = {(unixTime) => moment(unixTime).format('LLL ')}
                    type = 'number'
                    />
                <YAxis dataKey = 'state' tick={true}   domain = {['auto', 'auto']} name = 'Value' allowDecimals={false} scale={"linear"} label={{ value: this.state.inputGraphYaxis,  position: 'insideTopLeft' }}   />
<CartesianGrid />
<Tooltip  active={true}  coordinate={{ x: 100, y: 140 }} formatter={(value, name, props) => graphTooltip(value,name,props,this.state.current_type)}  labelFormatter={(value, name, props) => timeTooltip(value,name,props)}/>


<Line type="stepAfter" dataKey="state" stroke="#329fff"  strokeWidth="2px" dot={false} activeDot={{r: 8}}/>


            {/*    <Scatter
                  data = {this.state.graphData}
                  line = {{ stroke: '#329fff',strokeWidth: 1 }}
                  lineJointType = 'stepAfter'
                  lineType = 'joint'
                  name = 'Values'
                  shape={<CustomizedShape/>}
animationDuration={1000}
                />
                */}
                </LineChart >

                {/*}*/}
</ResponsiveContainer>

</div>



  <p>Data for 24h Period</p>
  <p><b>From:</b><Moment date={this.state.current_from} /></p>
  <p><b>To:</b><Moment date={this.state.current_to} /></p>
  {this.state.current_type==512?(
    <div>
  <p>Minimum recorded temperature:<b> {this.state.current_min}°C</b></p>
  <p>Maximum recorded temperature:<b> {this.state.current_max}°C</b></p>
  </div>
):("")}

<hr/>



  <p>Select Date</p>
  <FormControl type="date" onChange={this.dateChange} ></FormControl >
  <Button onClick={this.closeStats}>Close</Button>
  <CSVLink   filename={"logs_"+moment(this.state.current_to).format('YYYY-MM-DD hh:mm')+".csv"} data={this.state.csvData} target="_blank" >Export as CSV</CSVLink >
  <p>Alerts</p>
  { this.state.alertData.length==0 ?
    (<span>No alerts</span>)
    :
    (<ul>
      {
        this.state.alertData.map((l,i) =><li key={i}><b><Moment format="DD/MM hh:mm" unix>{l.time/1000}</Moment></b>:{l.msg}</li>)
      }
      </ul>
    )
}
</Well>):(<span></span>)}

            {!this.state.dashboard? (
              <div>

                <Panel className="hiddenPanel" >
                            <h3 className="panelTitle">Pendants <small>Add/Remove RF pendants</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
                            <Panel.Collapse   >
                              <Well>
                                {this.state.editPendant ? (
                                  <div>
                                  <input value={this.state.newPendant} onChange={this.newPendantChange}></input>
                                  <Button onClick={()=>this.addEditPendant()}>Add</Button>
                                  <Button onClick={()=>this.endEditPendant()}>Cancel</Button>
                                  </div>
                                ):(
                                  <div>
                                  <Button onClick={()=>this.startEditPendant()}>Enter a Pendant ID</Button>
                                </div>)
                                }



                              {this.state.pendant ?(<span>&nbsp;ID:<b>{this.state.pendantId}</b>&nbsp;<Moment fromNow>{this.state.pendantTime}</Moment>

                                { this.state.showPendantPair ?(<Button onClick={()=>this.addPendant()}>Assign Pendant</Button>):(<span></span>)}

                                </span>):(<span></span>)}
                              <h4>Assigned Pendants</h4>
                                {this.state.PENDANTS.map((l,i)=><div key={i} className="pendantList">ID:<b>{l}</b><Button onClick={()=>this.removePendant(i)}>Unassign</Button></div>)}
                                <p>When Pendant is pressed, Run</p>

                                {"PENDANT_SEEN" in this.state.macros ? (<MacroDisplay  data={this.state.macros["PENDANT_SEEN"]} outputs={this.state.outputs} vars={this.state.vars} index={"PENDANT_SEEN"} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>):

  (<Button onClick={()=>this.newMacroNamed("PENDANT_SEEN")}>Create Pendant Action</Button>)
}

                            </Well>
                            </Panel.Collapse>
              </Panel >


              <Panel className="hiddenPanel" >
                          <h3 className="panelTitle">Four Castor <small>Add a FourCastor to the system and configure settings</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
                          <Panel.Collapse   >
                            <Well>

                              {this.state.vars.CASTOR!=undefined ?(<span><b>ID:</b>{this.state.vars.CASTOR}&nbsp;({this.state.CASTOR_IP})<br/><br/></span>):(<span></span>)}
                              {this.state.editCastor ? (
                                <div>
                                <span><b>Typical format:</b>&nbsp;<i>4CAST_807D3AXXXXXX</i></span>
                                <input value={this.state.newCastor} onChange={this.newCastorChange} placeholder="4CAST_807D3AXXXXXX"></input>
                                <span>A Four Castor can only be linked with one altiom!</span><br/>

                                <Button onClick={()=>this.addEditCastor()}>Save</Button>
                                <Button onClick={()=>this.endEditCastor()}>Cancel</Button>
                                </div>
                              ):(
                                <div>
                                <Button onClick={()=>this.startEditCastor()}>Edit ID</Button>
                              </div>)
                              }


                              { this.state.castorSeen? ( <div><Bed data={this.state.castor}></Bed>
                                  <Button onClick={()=>this.send4Castor("C0T0")}>TARE</Button>
                                  <Button onClick={()=>this.send4Castor("firmware")}className="pull-right">Firmware Update</Button>
                                  <Button onClick={()=>this.send4Castor("C0t0")}className="pull-right">Reset Tare</Button>
                                  <hr/>
                                <p>Trigger Weight</p>
                                <Button onClick={()=>this.send4Castor("C0W0:20000")}>Weight trigger 10Kg</Button>
                                <Button onClick={()=>this.send4Castor("C0W0:20000")}>Weight trigger 20Kg</Button>
                                <Button onClick={()=>this.send4Castor("C0W0:30000")}>Weight trigger 30Kg</Button>
                                <p>Boundary</p>
                                <Button onClick={()=>this.send4Castor("C0B0:0:0:0:10")}>Left 10%</Button>
                                <Button onClick={()=>this.send4Castor("C0B0:0:10:0:0")}>Right 10%</Button>
                                <Button onClick={()=>this.send4Castor("C0B0:0:5:0:5")}>Left & Right 5%</Button>
                                <Button onClick={()=>this.send4Castor("C0B0:0:0:0:0")}>None</Button>
                                <p>Calibration</p>
                                <Button onClick={()=>this.send4Castor("C0C0:100")}>0%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:99")}>-1%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:98")}>-2%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:97")}>-3%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:96")}>-4%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:95")}>-5%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:94")}>-6%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:93")}>-7%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:92")}>-8%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:91")}>-9%</Button>
                                <Button onClick={()=>this.send4Castor("C0C0:90")}>-10%</Button>
                                </div>):("")}










                          </Well>
                          </Panel.Collapse>
            </Panel >


              <Panel className="hiddenPanel" >
                          <h3 className="panelTitle">Output Devices&nbsp;<small>Add/Remove/Control Output devices</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>

                          <Panel.Collapse   >
                            <Button onClick={()=>this.newOutput(blank_RF)}>New RF socket</Button>
                            <Button onClick={()=>this.newOutput(blank_RGB)}>New RGB</Button>
                            <Button onClick={()=>this.newOutput(blank_Relay)}>New Wired Output</Button><br/>
                            <div >{this.state.outputs.map((l,i) =><OutputDevice key={"OUT"+l.id} data={l} callback={this.sendit}  ></OutputDevice>)}</div>
                          </Panel.Collapse>
              </Panel>

              <Panel className="hiddenPanel">
                      <h3 className="panelTitle">Outstations<small>Configure Outstations</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
                      <Panel.Collapse>
                      {Object.keys(this.state.outstations).map((l,i) =><OutStation  id={l} data={this.state.outstations[l]} macros={this.state.macros} callback={this.sendit} ></OutStation>)}
                      </Panel.Collapse>
              </Panel>

              <Panel className="hiddenPanel" >
                    <h3 className="panelTitle">Actions <small>Setup and manage macros</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
                    <Panel.Collapse   >
                        <Button onClick={()=>this.newMacro()}>Create New Action</Button>
                        {<div className="pull-right"><Button onClick={()=>this.sortByChange("name")}>Sort Name</Button><Button onClick={()=>this.sortByChange("createdDate")}>Sort Time</Button></div>}
                        <PanelGroup id="MactoGroup">
                        {Object.keys(this.state.macros).sort((a,b)=>this.macro_sort(a,b,this.state.macroSortByKey)).map((m,i) =><MacroDisplay key={i}  data={this.state.macros[m]} outputs={this.state.outputs} vars={this.state.vars} index={m} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>)}
                        </PanelGroup>
                    </Panel.Collapse   >
              </Panel>


              <Panel className="hiddenPanel">

                <h3 className="panelTitle">Events <small>Configure and manage alert logic</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>

<Panel.Collapse   >

<Button onClick={()=>this.createLogicOpen()}>New Logic</Button>


{Object.keys(this.state.logic).sort((a,b)=>this.logicSort(a,b,'name')).map((l,i)  =><Well key={"LogicWell"+i}>

              <LogicDisplay key={i} id={l} data={this.state.logic[l]} callback={this.logicChange} ></LogicDisplay>

              <h4>Then</h4>

              <b>True</b><br/>
              <MacroDisplay  data={this.state.macros[this.state.logic[l].MacroTrue]} outputs={this.state.outputs} vars={this.state.vars} index={this.state.logic[l].MacroTrue} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>

              <b>False</b><br/>
              <MacroDisplay  data={this.state.macros[this.state.logic[l].MacroFalse]} outputs={this.state.outputs} vars={this.state.vars} index={this.state.logic[l].MacroFalse} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>


              </Well>

)}
</Panel.Collapse >

              </Panel>

{this.checkVersion("2.2.3.19")==true ? (
              <Panel className="hiddenPanel" >
                          <h3 className="panelTitle">Schedule &nbsp;<small>Start an action at a certain time or interval</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>

                          <Panel.Collapse   >

                              <Button onClick={()=>this.createSchedOpen()}>New</Button>
                            {/*}<Button onClick={()=>this.newOutput(blank_RF)}>New RF socket</Button>*/}
                            {/*}<Button onClick={()=>this.newOutput(blank_RGB)}>New RGB</Button>*/}
                            {/*}<Button onClick={()=>this.newOutput(blank_Relay)}>New Wired Output</Button><br/>*/}
                            <div >{Object.keys(this.state.schedule).map((l,i)  =>

                              <Well>
                              <b>Time</b>
                              <ScheduleItem key={"SCH"+l.id} data={this.state.schedule[l]} callback={this.schedChange}  >


                              </ScheduleItem>

                              <b>Run</b>
                              <MacroDisplay  data={this.state.macros[this.state.schedule[l].macro]} outputs={this.state.outputs} vars={this.state.vars} index={this.state.schedule[l].macro} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>
                              </Well>

                          )}</div>
                          </Panel.Collapse>
              </Panel>):("")}

              {this.checkVersion("2.2.3.22")==true ? (
                            <Panel className="hiddenPanel" >
                                        <h3 className="panelTitle">Scripts &nbsp;<small>Run/Modify Scripts</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>

                                        <Panel.Collapse   >

                                        {((new Date().getTime())/1000-this.state.SCRIPT_EDIT)>3600 ? (
                                        <Well>
                                        <h4>Enter Authorisation to edit </h4>
                                        <input type="password" value={this.state.password_script} onChange={e => this.setState({ password_script:e.target.value })}></input>
                                        <Button onClick={this.script_unlock}>Unlock</Button>
                                        </Well>):
                                        (<div>

                                          {/*}<Button onClick={()=>this.newOutput(blank_RF)}>New RF socket</Button>*/}
                                          {/*}<Button onClick={()=>this.newOutput(blank_RGB)}>New RGB</Button>*/}
                                          {/*}<Button onClick={()=>this.newOutput(blank_Relay)}>New Wired Output</Button><br/>*/}
                                          <div >{this.state.scripts.map((l,i)  =>

                                            <Well key={"script"+l.name}>
                                            <b>Script: {l.name}</b><br/>
                                              <Button onClick={()=>this.load_script(l.name)}>Edit</Button>
                                              <Button onClick={()=>this.run_script(l.name)}>Run</Button><br/>
                                            <b>State:{l.state}</b><br/>
                                            <b>Log:<span className="logCode">{l.feedback}</span></b>
                                            <hr/>
                                            </Well>




                                        )}
                                        <span>Scripts can only be within the /mnt/update/scripts/ location</span>
                                        <Well><h4>Name:</h4><input type="text" value={this.state.script_name} onChange={e => this.setState({ script_name:e.target.value })} ></input> <Button onClick={this.save_script}>Save</Button>&nbsp;<Button onClick={()=>this.run_script(this.state.script_name)}>Run</Button>&nbsp;<Button onClick={()=>this.load_script(this.state.script_name)}>Reload from disk</Button><Button className="pull-right">Delete</Button>
                                        <Button className="pull-right" onClick={this.script_lock}>Lock</Button>
                                        <br/>
                                        <br/>
                                        <div className="codebackground">
                                        <Editor
                                                value={this.state.code}
                                                onValueChange={code => this.setState({ code })}
                                                highlight={code => highlight(code, languages.js)}
                                                padding={10}
                                                style={{
                                                  fontFamily: '"Fira code", "Fira Mono", monospace',
                                                  fontSize: 12,
                                                }}
                                              />
                                              </div>
                                              </Well>
                                        </div>
                                        </div>)}



                                        </Panel.Collapse>
                            </Panel>):("")}


              <Panel className="hiddenPanel">
              <h3 className="panelTitle">Variables <small>View and manage variable values</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
            <Panel.Collapse   >


{/*<VarModifyAll  data={"PAGER_IP"} callback={this.varEditCallback} editMode={true}/>*/}

{/*<VarModifyAll  data={l} callback={this.varEditCallback} editMode={false}/>*/}




<Well>
  <h3>Variables&nbsp;<Button onClick={this.newVariable}>New Variable</Button></h3>

{  this.state.variableEdit ?(<VarModifyAll key="varEdit" editMode={this.state.newVarMode} data={this.state.variableData} callback={this.varEditCallback} />):(<div>{this.state.uservars.map((l,i) =>
<span key={i}><b>{l.id}:</b>{JSON.stringify(l.value)} <Button onClick={()=>this.startvarEdit(l)}>EDIT</Button><br/></span>)}</div>)}
</Well>







{/*<span key={i}><b>{l.id}:</b>{JSON.stringify(l.value)} <Button>EDIT</Button><br/></span>*/}

</Panel.Collapse >



</Panel>

              </div>
            ):("")}

            {/*
            <h2>Output Devices</h2>
            <p>Altiom Needs to provide output JSON +last states!</p>
            <hr/>
            */
            }
            {!this.state.dashboard? (<div>
                {this.state.advanced?(
                    <div>



{this.state.DALI_ENABLED!=undefined ?
                    (<Panel className="hiddenPanel">
                    <h3 className="panelTitle">DALI SETUP <small>Setup DALI devices</small>
                    <Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle>
                    </h3>
                  <Panel.Collapse   >



                    <Well>
                    <p>Send a raw command to a bus</p>
                    <span>BUS:</span><input className="debuginput" type="number" value={this.state.dali_bus} onChange={e => this.setState({ dali_bus:e.target.value })}></input>
                    <span>ADDR:</span><input className="debuginput" type="number" value={this.state.dali_addr} onChange={e => this.setState({ dali_addr:e.target.value })}></input>
                    <span>CMD:</span><input className="debuginput" type="number" value={this.state.dali_cmd} onChange={e => this.setState({ dali_cmd:e.target.value })}></input>
                    <span>RSP:</span><input className="debuginput" type="number" value={this.state.dali_response} onChange={e => this.setState({ dali_response:e.target.value })}></input>
                    <Button onClick={()=>this.DaliTX()}>SEND</Button><br/>
                    <p><b>Bus</b> 0/1 Which Dali bus should the message be sent out on.</p>
                    <p><b>Address (Byte 1)</b> Address to send message to , also used for special commands</p>
                    <p><b>Command (Byte 2)</b> Command to send out to device</p>
                    <p><b>RSP</b> 0/1 expect a response from the bus</p>

                    </Well>

                    <Well>
                    <p>TOGGLE SEQUENCE</p>
                    <p><span>toggles address on and off every second.</span></p>
                    <p><span>Automaticly stops when other dali commands are issued from this interface</span></p>
                    <span>Address to toggle:</span>

                    <p>

                  <span>BUS:</span>
                  <select className="debuginput" value={this.state.dali_bus} onChange={e => this.setState({ dali_bus:e.target.value })}>
                  <option value={0x00} >BUS 0 (right)</option>
                  <option value={0x01} >BUS 1 (middle)</option>
                  <option value={0x01} >BUS 2 (left)</option>
                  </select>
                  <span>ADDRESS:</span>
                    <select className="debuginput" value={this.state.dali_addr} onChange={e => this.setState({ dali_addr:e.target.value })}>
                      <option value={0x00} >Select</option>
                      <option value={0xFF} >ALL</option>
                      <option value={0x80|1} >Group 0</option>
                      <option value={0x80|1|1<<1} >Group 1</option>
                      <option value={0x80|1|2<<1} >Group 2</option>
                      <option value={0x80|1|3<<1} >Group 3</option>
                      <option value={0x80|1|4<<1} >Group 4</option>
                      <option value={0x80|1|5<<1} >Group 5</option>
                      <option value={0x80|1|6<<1} >Group 6</option>
                      <option value={0x80|1|7<<1} >Group 7</option>
                      <option value={0x80|1|8<<1} >Group 8</option>
                      <option value={0x80|1|9<<1} >Group 9</option>
                      <option value={0x80|1|10<<1} >Group 10</option>
                      <option value={0x80|1|11<<1} >Group 11</option>
                      <option value={0x80|1|12<<1} >Group 12</option>
                      <option value={0x80|1|13<<1} >Group 13</option>
                      <option value={0x80|1|14<<1} >Group 14</option>
                      <option value={0x80|1|15<<1} >Group 15</option>
                      <option value={1} >Address 0</option>
                      <option value={1|1<<1} >Address 1</option>
                      <option value={1|2<<1} >Address 2</option>
                      <option value={1|3<<1} >Address 3</option>
                      <option value={1|4<<1} >Address 4</option>
                      <option value={1|5<<1} >Address 5</option>
                      <option value={1|6<<1} >Address 6</option>
                      <option value={1|7<<1} >Address 7</option>
                      <option value={1|8<<1} >Address 8</option>
                      <option value={1|9<<1} >Address 9</option>
                      <option value={1|10<<1} >Address 10</option>
                      <option value={1|11<<1} >Address 11</option>
                      <option value={1|12<<1} >Address 12</option>
                      <option value={1|13<<1} >Address 13</option>
                      <option value={1|14<<1} >Address 14</option>
                      <option value={1|15<<1} >Address 15</option>
                      <option value={1|16<<1} >Address 16</option>
                      <option value={1|17<<1} >Address 17</option>
                      <option value={1|18<<1} >Address 18</option>
                      <option value={1|19<<1} >Address 19</option>
                      <option value={1|20<<1} >Address 20</option>
                      <option value={1|21<<1} >Address 21</option>
                      <option value={1|22<<1} >Address 22</option>
                      <option value={1|23<<1} >Address 23</option>
                      <option value={1|24<<1} >Address 24</option>
                      <option value={1|25<<1} >Address 25</option>
                      <option value={1|26<<1} >Address 26</option>
                      <option value={1|27<<1} >Address 27</option>
                      <option value={1|28<<1} >Address 28</option>
                      <option value={1|29<<1} >Address 29</option>
                      <option value={1|30<<1} >Address 30</option>
                      <option value={1|31<<1} >Address 31</option>
                      <option value={1|32<<1} >Address 32</option>
                      <option value={1|33<<1} >Address 33</option>
                      <option value={1|34<<1} >Address 34</option>
                      <option value={1|35<<1} >Address 35</option>
                      <option value={1|36<<1} >Address 36</option>
                      <option value={1|37<<1} >Address 37</option>
                      <option value={1|38<<1} >Address 38</option>
                      <option value={1|39<<1} >Address 39</option>
                      <option value={1|40<<1} >Address 40</option>
                      <option value={1|41<<1} >Address 41</option>
                      <option value={1|42<<1} >Address 42</option>
                      <option value={1|43<<1} >Address 43</option>
                      <option value={1|44<<1} >Address 44</option>
                      <option value={1|45<<1} >Address 45</option>
                      <option value={1|46<<1} >Address 46</option>
                      <option value={1|47<<1} >Address 47</option>
                      <option value={1|48<<1} >Address 48</option>
                      <option value={1|49<<1} >Address 49</option>
                      <option value={1|50<<1} >Address 50</option>
                      <option value={1|51<<1} >Address 51</option>
                      <option value={1|52<<1} >Address 52</option>
                      <option value={1|53<<1} >Address 53</option>
                      <option value={1|54<<1} >Address 54</option>
                      <option value={1|55<<1} >Address 55</option>
                      <option value={1|56<<1} >Address 56</option>
                      <option value={1|57<<1} >Address 57</option>
                      <option value={1|58<<1} >Address 58</option>
                      <option value={1|59<<1} >Address 59</option>
                      <option value={1|60<<1} >Address 60</option>
                      <option value={1|61<<1} >Address 61</option>
                      <option value={1|62<<1} >Address 62</option>
                      <option value={1|63<<1} >Address 63</option>
                    </select>
                    </p>
                    <h2>{this.state.dalitogglestate}</h2>


                    <Button onClick={()=>this.daliToggleStart()}>Start</Button><Button onClick={()=>this.daliToggleStop()}>Stop</Button><br/>


                    </Well>



                    <h3>Bus 0</h3>
                    <Well>
                    <h4>Control</h4>
                    <p><Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:255,command:5,response:0})}>All ON</Button><Button    onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:255,command:0,response:0})}>All OFF</Button></p>


                    <p>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:254,command:0,response:0})}>0%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:254,command:179,response:0})}>20%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:254,command:198,response:0})}>40%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:254,command:217,response:0})}>60%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:254,command:235,response:0})}>80%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:0,address:254,command:254,response:0})}>100%</Button>
                    </p>



                    <h4>Setup (run once)</h4>

                    <Button  bsStyle="warning"  onClick={()=>this.sendRaw({cmd:"DALI",command:"find_unaddressed_items",bus:0})}>Assign Addresses</Button><br/><br/>
                    <Button bsStyle="danger"  onClick={()=>this.sendRaw({cmd:"DALI",command:"reset_everything",bus:0})}>RESET ALL DATA (DANGER)</Button>


                    <hr/>



                    <h4>Dali Devices</h4>
                    <p><Button  bsStyle="info" onClick={()=>this.sendRaw({cmd:"DALI",command:"scan_bus",bus:0})}>Scan for assigned devices</Button><br/></p>
                    <div >{Object.keys(this.state.dali_bus0).map((l,i) =><DaliDisplay key={"Dali0"+i} addr={parseInt(l)} bus={0} data={this.state.dali_bus0[l]}  dali_all={this.state.dali_bus0}  callback={this.dali_callback}  ></DaliDisplay>)}</div>
                    </Well>


                    <h3>Bus 1</h3>
                      1

                    <Well>
                    <h4>Control</h4>
                    <p><Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:255,command:5,response:0})}>All ON</Button><Button    onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:255,command:0,response:0})}>All OFF</Button></p>
                    <p>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:254,command:0,response:0})}>0%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:254,command:179,response:0})}>20%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:254,command:198,response:0})}>40%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:254,command:216,response:0})}>60%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:254,command:235,response:0})}>80%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:1,address:254,command:254,response:0})}>100%</Button>
                    </p>


                    <h4>Setup (run once)</h4>

                    <Button  bsStyle="warning"  onClick={()=>this.sendRaw({cmd:"DALI",command:"find_unaddressed_items",bus:1})}>Assign Addresses</Button><br/><br/>
                    <Button bsStyle="danger"  onClick={()=>this.sendRaw({cmd:"DALI",command:"reset_everything",bus:1})}>RESET ALL DATA (DANGER)</Button>


                    <hr/>

                    <h4>Dali Devices</h4>
                    <p><Button  bsStyle="info" onClick={()=>this.sendRaw({cmd:"DALI",command:"scan_bus",bus:1})}>Scan for assigned devices</Button><br/></p>
                    <div >{Object.keys(this.state.dali_bus1).map((l,i) =><DaliDisplay key={"Dali1"+i} addr={parseInt(l)} bus={1} data={this.state.dali_bus1[l]}  dali_all={this.state.dali_bus1}  callback={this.dali_callback}  ></DaliDisplay>)}</div>
                    </Well>



                    <h3>Bus 2</h3>


                    <Well>
                    <h4>Control</h4>
                    <p><Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:255,command:5,response:0})}>All ON</Button><Button    onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:255,command:0,response:0})}>All OFF</Button></p>
                    <p>

                    //161
                    //254
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:254,command:0,response:0})}>0%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:254,command:179,response:0})}>20%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:254,command:198,response:0})}>40%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:254,command:216,response:0})}>60%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:254,command:235,response:0})}>80%</Button>
                    <Button onClick={()=>this.sendRaw({cmd:"PIC",type:"dali",bus:2,address:254,command:254,response:0})}>100%</Button>
                    </p>


                    <h4>Setup (run once)</h4>

                    <Button  bsStyle="warning"  onClick={()=>this.sendRaw({cmd:"DALI",command:"find_unaddressed_items",bus:2})}>Assign Addresses</Button><br/><br/>
                    <Button bsStyle="danger"  onClick={()=>this.sendRaw({cmd:"DALI",command:"reset_everything",bus:2})}>RESET ALL DATA (DANGER)</Button>


                    <hr/>

                    <h4>Dali Devices</h4>
                    <p><Button  bsStyle="info" onClick={()=>this.sendRaw({cmd:"DALI",command:"scan_bus",bus:2})}>Scan for assigned devices</Button><br/></p>
                    <div >{Object.keys(this.state.dali_bus2).map((l,i) =><DaliDisplay key={"Dali1"+i} addr={parseInt(l)} bus={2} data={this.state.dali_bus2[l]}  dali_all={this.state.dali_bus2}  callback={this.dali_callback}  ></DaliDisplay>)}</div>
                    </Well>
</Panel.Collapse >
</Panel>):("")}
                    <hr/>
                      <h3>Advanced</h3>
                      <span>Setup of some built in macros</span>


                      <h4>Run on Boot</h4>
                      {"onboot" in this.state.macros ? (<MacroDisplay  data={this.state.macros["onboot"]} outputs={this.state.outputs} vars={this.state.vars} index={"onboot"} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>):
                    (<Button onClick={()=>this.newMacroNamed("onboot")}>Create Action</Button>)
                    }

                    <h4>Safe Mode On</h4>
                    {"safeon" in this.state.macros ? (<MacroDisplay  data={this.state.macros["safeon"]} outputs={this.state.outputs} vars={this.state.vars} index={"safeon"} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>):
                  (<Button onClick={()=>this.newMacroNamed("safeon")}>Create Action</Button>)
                  }


                  <h4>Safe Mode Off</h4>
                  {"safeoff" in this.state.macros ? (<MacroDisplay  data={this.state.macros["safeoff"]} outputs={this.state.outputs} vars={this.state.vars} index={"safeoff"} macros={this.state.macros} callback={this.macrofunc} events={this.state.logic} schedule={this.state.schedule}></MacroDisplay>):
                (<Button onClick={()=>this.newMacroNamed("safeoff")}>Create Action</Button>)
                }



                        {/*
                <h4>Script Record</h4>
                {this.state.script_log_en ? (<Button onClick={e => this.setState({ script_log_en:false })}>Stop</Button>):(<Button onClick={e => this.setState({ script_log_en:true })}>Record</Button>)}
                <br/>

                <textarea value={JSON.stringify(this.state.script_log)}></textarea>
                */}


{this.checkVersion("2.2.3.24")==true ? (<div>





        <Panel className="hiddenPanel">
        <h3 className="panelTitle">Shell <small>run shell commands</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
      <Panel.Collapse   >
              <div>
                <AltiomTerminal data={this.state.shelldata} callback={this.sendit} />
                </div>
    </Panel.Collapse>

</Panel>
            </div>)
            :("")}</div>):(          <span></span>)}
</div>):("")}

            {!this.state.dashboard? (<div>

                {this.state.advanced?(<div>
            <hr/>

            <hr/>
          </div>):(<span></span>)}</div>):("")}

<br/>

{this.state.dashboard? (<div>



  {this.checkVersion("2.2.3.18")==true ? (
  <Panel className="hiddenPanel" >
        <h3 className="panelTitle">Camera Log&nbsp;<small>View captured images</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>
        <Panel.Collapse   >


            <PanelGroup id="imgGroup">
                <center>
                <h4>{this.state.image_text}</h4>
                <img src={this.state.image_view}></img>
                </center>
                <br/>
                <br/>

            {this.state.imglist.map(function(m,i) {

              let path=m.split("/mnt/update/web")
              let url="http://192.168.10.48"+path[1]
              let img_name=path[1].split("/")
              img_name=img_name[img_name.length-1]

              return (<span><Button onClick={()=>this.loadImage(m)} data-image={m}>View {img_name}</Button>&nbsp;</span>)



            },this)}
            </PanelGroup>
        </Panel.Collapse   >
  </Panel>):("")}


{/*}<Button onClick={()=>this.createLogicOpen()}>New Logic</Button>*/}
<Button className="pull-right" onClick={this.newTempLogic} >Configure Temperature Alerts</Button>
{this.state.showAll?(<h3>All Alerts&nbsp;<Button onClick={this.showAllAlerts}>Show Only Active</Button></h3>):(<h3>Active Alerts&nbsp;<Button onClick={this.showAllAlerts}>Show All</Button></h3>)}

    {Object.keys(this.state.logic).map((l,i) =><TempAlert key={l} alert={true} showAll={this.state.showAll} callback={this.tempcallback} logicid={l}  data={this.state.logic[l]} edit={false} new={false} inputs={this.state.inputs} macro={this.state.alertMacro} vars={this.state.uservars}></TempAlert>)}

</div>):(<span><Button onClick={this.newTempLogic} >Configure Temperature Alerts</Button>
<br/><br/></span>)}



{this.state.dashboard? (<div>



  <Panel className="hiddenPanel">
  <h3 className="panelTitle">Local Data Download&nbsp;<small>Download of temperature report data</small><Panel.Toggle  className="pull-right"><Button color="primary" style={{ marginBottom: '1rem' }}>Show/Hide</Button></Panel.Toggle></h3>

<Panel.Collapse>
<Well>
<p></p>
<h3>Select a Week</h3>

<i>Download summary for selected week</i>
<FormControl type="date" onChange={this.weekdateChange} value={this.state.week_date}></FormControl >
<h4>{this.state.summaryInfo}</h4>
{this.state.summaryDownload?(
<CSVLink   filename={"Week_summary_"+moment(this.state.week_date).format('YYYY-WW')+"_"+this.state.ROOM+".csv"}data={this.state.summaryCSV} target="_blank" >Download CSV</CSVLink >):("")}

<hr/>
<h3>Download Range</h3>
<i>data collated to the nearest week</i>
<FormGroup>
<b>From:</b>
<FormControl  type="date" onChange={this.weekRangeStartChange} value={this.state.weekRangeStart}></FormControl >
<b>To:</b>
<FormControl  type="date" onChange={this.weekRangeEndChange} value={this.state.weekRangeEnd}></FormControl >
</FormGroup>
<Button disabled={this.state.weekRangeLoading} onClick={this.getRange}>Get Range</Button>
<h4>{this.state.weekRangeState}</h4>
{this.state.weekRangeDownload?(
<CSVLink   filename={"Range_summary_From_"+moment(this.state.weekRangeStart).format('YYYY-MM-DD')+"_TO_"+moment(this.state.weekRangeEnd).format('YYYY-MM-DD')+this.state.ROOM+".csv"}data={this.state.weekRangeCSV} target="_blank" >Download CSV</CSVLink >):("")}




</Well>
</Panel.Collapse>
</Panel>
</div>
):(<span></span>)}



{!this.state.dashboard? (
<Well>
  <h3>Contact Lists&nbsp;<Button onClick={this.newContactList}>Add New</Button></h3>
  <p><i>For an alert when an altiom goes offline create a list with the id OFFLINE_CONTACT_LIST</i></p>
{  this.state.contactEdit ?(<VarModify key="contactEdit" editMode={this.state.newContact} data={this.state.contactData} type="CONTACT" callback={this.varEditCallback} />):(<div>{this.state.uservars.map((l,i) =>
  <ContactList data={l} key={i} editIndex={i} callback={this.editContactList} varfeedback={this.state.editfeedback}></ContactList>)}</div>)}
</Well>):(<span></span>)}



{this.state.dashboard? (<Button onClick={this.DashToggle}>Edit Device</Button>):(<div><Button onClick={this.DashToggle}>Dashboard</Button><Button onClick={this.AdvacnedToggle}>Advanced</Button></div>)}



            {/*
            <h2>Variables</h2>
            <div className="varFlex">
            {Object.keys(this.state.vars).map((v,i) =><div className="vardiv" key={i}  ><i>{v}</i>:{JSON.stringify(this.state.vars[v])} </div>)}
            </div>
            <p>Alter /Create Variables</p>
            <hr/>
          */}
          {/*
            <h2>Config</h2>
            <p>Download Config</p>
            <p>Uplaod Config</p>
            <p>Reload Config</p>
            <p>Reload Config</p>
            */}
{/*<ActionCreate sendmsg={this.sendmsg}></ActionCreate>*/}

{/*<VarModify  data={testVAR}/>*/}

{/*
  {Object.keys(this.state.macros).map((m,i) =>  <MacroCreate data={this.state.macros[m]} vars={this.state.vars} sendmsg={this.sendmsg} macro_key={m}></MacroCreate>)}
*/}


{/*  <Button onClick={()=>this.newMacro()}>Create New Macro</Button> */}

  {/*  {this.state.newMacro ? (<MacroCreate data={this.state.newMacroData} vars={this.state.vars} sendmsg={this.sendmsg} callback={this.macrofunc} macro_key={this.state.newmacrokey}></MacroCreate>):(<span></span>)}*/}


</Jumbotron>

<Modal key="macroModal" show={this.state.newMacro} bsSize="large" backdrop="static"   backdropClassName="backdropOveride"  aria-labelledby="contained-modal-title-lg" onHide={this.handleCloseMacro}>
  <Modal.Header closeButton>
    <Modal.Title id="contained-modal-title-lg">Macro Edit</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Jumbotron className="jumbopad">
      <MacroCreate data={this.state.newMacroData} vars={this.state.uservars} sendmsg={this.sendit} outputs={this.state.outputs} callback={this.macrofunc} macro_key={this.state.newmacrokey} macros={this.state.macros} events={this.state.logic} schedule={this.state.schedule}></MacroCreate>
    </Jumbotron>
  </Modal.Body>
</Modal>



          <Modal key="tempLogicModal" show={this.state.newTemperatureLogic} backdrop="static" bsSize="large" aria-labelledby="contained-modal-title-lg" onHide={this.handleCloseTemperatureLogic}>
            <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">Temperature Alerts</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Jumbotron className="jumbopad">
                <h3>Manage temperature alerts</h3>
                    {this.state.tempedit?(<TempAlert callback={this.tempcallback} edit={true} new={this.state.tempNew} logicid={this.state.templogicid} data={this.state.tempLogic} inputs={this.state.inputs} macro={this.state.tempMacro} vars={this.state.uservars}/>):(<div>
                    {Object.keys(this.state.logic).map((l,i) =><div key={"TempAlert"+i}><TempAlert callback={this.tempcallback} logicid={l} key={i}  data={this.state.logic[l]} edit={false} new={false} inputs={this.state.inputs} macro={this.state.alertMacro} vars={this.state.uservars}></TempAlert></div>)}
                    <TempAlert callback={this.tempcallback} edit={false} new={true} inputs={this.state.inputs} macro={this.state.alertMacro} vars={this.state.uservars}/></div>)}
                </Jumbotron>
            </Modal.Body>
          </Modal>




          <Modal key="Schedulemodal" show={this.state.alterSchedule} backdrop="static"  bsSize="large" aria-labelledby="contained-modal-title-lg" onHide={this.handleCloseShedule}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">Add/Edit Schedule</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ScheduleCreate data={this.state.tempschedule}  macros={this.state.macros} callback={this.schedChange}></ScheduleCreate>
                {/*<LogicCreate data={this.state.tempLogicData} logicid={this.state.tempLogicid} macros={this.state.macros} callback={this.logicChange} inputs={this.state.inputs}></LogicCreate>*/}

            </Modal.Body>
          </Modal>




          <Modal key="Inmodal" show={this.state.alterInput} bsSize="large" backdrop="static"  aria-labelledby="contained-modal-title-lg" onHide={this.handleClosealterInput}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">Alter Input</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Jumbotron className="jumbopad" key="inputeditData">
                {this.state.inputs.map((l,i) =><InputEdit data={l} key={l.id} inputIndex={i} callback={this.sendit} ></InputEdit>)}
              </Jumbotron>
            </Modal.Body>
          </Modal>
          <Modal key="Logicmodal" show={this.state.alterLogic} backdrop="static"  bsSize="large" aria-labelledby="contained-modal-title-lg" onHide={this.handleCloseLogic}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">Add/Edit Events</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <LogicCreate data={this.state.tempLogicData} logicid={this.state.tempLogicid} macros={this.state.macros} callback={this.logicChange} inputs={this.state.inputs} outputs={this.state.outputs} vars={this.state.uservars}></LogicCreate>

            </Modal.Body>
          </Modal>


          <Modal key="Helpmodal" show={this.state.showHelp} backdrop="static"  bsSize="large" aria-labelledby="contained-modal-title-lg" onHide={this.handleCloseHelp}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-lg">Help</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <h3>RF Help</h3>

                <p>Each socket can be registered to 6 codes a code consists of a group(0-255) and id(0-255)</p>
                <hr/>
                <h4>Pairing</h4>
                <p>Press the button on the socket for 1/2 a second the light will start to flash</p>
                <p>Press the "ON" button for desired id the socket will cycle on and off (click click click)</p>
                <p><b>Unparing.</b> Same step as above but press the "OFF" button</p>
                <hr/>

                <h4>Reset Socket</h4>
                <p>To clear all registered codes on a socket. Press and hold the button untill it flashes rapidly( aproximatly 6 seconds) Then press the button again. The socket will click to confirm </p>


            </Modal.Body>
          </Modal>

          <div className="discreteInfo pull-right">
                    <b>ID:</b> {this.state.uid}&nbsp;<b>Version:</b>{this.state.version}&nbsp;<b>Local IP:</b> {this.state.ALTIOM_IP}&nbsp;<b>Remote IP:</b>{this.state.INTERNET_IP}&nbsp;
                    <b>Last Reboot:</b>{new Date(this.state.ALTIOM_UPTIME*1000).toLocaleString()}&nbsp;
                    <b>Last Message:</b><Moment fromNow>{this.state.last_seen}</Moment>
                    </div>
          </div>
        );
    }
}
/*
<Modal.Footer>
  <Button onClick={this.props.onHide}>Close</Button>
</Modal.Footer>


*/



// WEBPACK FOOTER //
// ./src/programmerContainers/ProgramHome.js